__turbopack_context__.v({
  "privacyPolicyContainer": "_09ENLG_privacyPolicyContainer",
});
